import { isXMLType } from "../natives/xml";
export function axEquals(left, right, sec) {
    // See E4X spec, 11.5 Equality Operators for why this is required.
    if (isXMLType(left, sec)) {
        return left.equals(right);
    }
    if (isXMLType(right, sec)) {
        return right.equals(left);
    }
    return left == right;
}
